/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import FeaturesService from 'ember-feature-flags/services/features';
import { inject as service } from '@ember/service';

export default class AllSubscribedNoTopicsBanner extends Component {
  @service features!: FeaturesService;

  get bannerTitle() {
    return "To enable topics, you cannot send to all 'subscribed people'";
  }
}
